import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '@shared/services/authentication.service';
import { NGXLogger } from 'ngx-logger';
import { Observable, switchMap, take } from 'rxjs';

const LOG_PREFIX = '[Interceptor][JWT] ';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  logger: NGXLogger = inject(NGXLogger);

  constructor(private _authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this._authenticationService.idTokenResult.pipe(
      take(1),
      switchMap((res) => {
        try {
          if (request.url && request.url.includes('storage.googleapis.com')) {
            return next.handle(request);
          }
        } catch (e) {
          console.warn(LOG_PREFIX + 'Error parsing request URL', e);
        }

        if (res) {
          request = request.clone({
            setHeaders: {
              'X-AUTH-TOKEN': res.token
            }
          });
        }
        return next.handle(request);
      })
    );
  }
}
